import { createAction, props } from '@ngrx/store';
import { ICreatePrograma, IDeleteProgramaResponse, IPrograma, IUpdatePrograma, IUpdateProgramaResponse } from 'src/app/interfaces/programas.insterface';

export const GetProgramas = createAction(
    '[Programas] Get Programas',
  );

export const GetProgramasSuccess = createAction(
    '[Programas] Get Programas Success',
    props<{programas: IPrograma[]}>()
  );

export const CreatePrograma = createAction(
    '[Programas] Create Programa',
    props<{programa: ICreatePrograma}>()
  );

export const CreateProgramaSuccess = createAction(
    '[Programas] Create Programa Success',
    props<{programa: IPrograma}>()
  );

export const DeletePrograma = createAction(
    '[Programas] Delete Programa',
    props<{id: string}>()
  );

export const DeleteProgramaSuccess = createAction(
    '[Programas] Delete Programa Success',
    props<{programa: IDeleteProgramaResponse}>()
  );

export const UpdatePrograma = createAction(
    '[Programas] Update Programa',
    props<{id: string, programa: IUpdatePrograma }>()
  );

export const UpdateProgramaSuccess = createAction(
    '[Programas] Update Programa Success',
    props<{programa: IUpdateProgramaResponse }>()
  );
